<template>
  <div class="app-container">
    <list ref="list">
       
       
    </list>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/business/stock/transceiverstorage/list'


export default {
  mixins: [curdMixins],
  components: {
    list,
  },
  data(){
    return {
    }
  },
  mounted() {
    if (!this.$permission.canPrice()) {
      const findIndex = this.$refs.list.$refs.list.tableList.findIndex(item => item.label == "期初结存");
      if (findIndex >= 0) {
        const i = this.$refs.list.$refs.list.tableList[findIndex].children.findIndex(item => item.tableName == "BeginAveragePrice");
        if (i >= 0) this.$refs.list.$refs.list.tableList[findIndex].children.splice(i, 1);
        const i1 = this.$refs.list.$refs.list.tableList[findIndex].children.findIndex(item => item.tableName == "BeginAmount");
        if (i1 >= 0) this.$refs.list.$refs.list.tableList[findIndex].children.splice(i1, 1);
      }
      const findIndex1 = this.$refs.list.$refs.list.tableList.findIndex(item => item.label == "本期入库");
      if (findIndex1 >= 0) {
        const i = this.$refs.list.$refs.list.tableList[findIndex1].children.findIndex(item => item.tableName == "InBasePrice");
        if (i >= 0) this.$refs.list.$refs.list.tableList[findIndex1].children.splice(i, 1);
        const i1 = this.$refs.list.$refs.list.tableList[findIndex1].children.findIndex(item => item.tableName == "InAmount");
        if (i1 >= 0) this.$refs.list.$refs.list.tableList[findIndex1].children.splice(i1, 1);
      }
      const findIndex2 = this.$refs.list.$refs.list.tableList.findIndex(item => item.label == "本期出库");
      if (findIndex2 >= 0) {
        const i = this.$refs.list.$refs.list.tableList[findIndex2].children.findIndex(item => item.tableName == "OutBasePrice");
        if (i >= 0) this.$refs.list.$refs.list.tableList[findIndex2].children.splice(i, 1);
        const i1 = this.$refs.list.$refs.list.tableList[findIndex2].children.findIndex(item => item.tableName == "OutAmount");
        if (i1 >= 0) this.$refs.list.$refs.list.tableList[findIndex2].children.splice(i1, 1);
      }
      const findIndex3 = this.$refs.list.$refs.list.tableList.findIndex(item => item.label == "期末结存");
      if (findIndex3 >= 0) {
        const i = this.$refs.list.$refs.list.tableList[findIndex3].children.findIndex(item => item.tableName == "FinalAveragePrice");
        if (i >= 0) this.$refs.list.$refs.list.tableList[findIndex3].children.splice(i, 1);
        const i1 = this.$refs.list.$refs.list.tableList[findIndex3].children.findIndex(item => item.tableName == "FinalAmount");
        if (i1 >= 0) this.$refs.list.$refs.list.tableList[findIndex3].children.splice(i1, 1);
      }
    }

  },
  
};
</script>